export const LIST_ABNORMAL_RISK_LEVEL_REQUEST = 'LIST_ABNORMAL_RISK_LEVEL_REQUEST'
export const LIST_ABNORMAL_RISK_LEVEL_SUCCESS = 'LIST_ABNORMAL_RISK_LEVEL_SUCCESS'
export const LIST_ABNORMAL_RISK_LEVEL_FAIL = 'LIST_ABNORMAL_RISK_LEVEL_FAIL'

export const LIST_ABNORMAL_RISK_LEVEL_SUMMARY_REQUEST = 'LIST_ABNORMAL_RISK_LEVEL_SUMMARY_REQUEST'
export const LIST_ABNORMAL_RISK_LEVEL_SUMMARY_SUCCESS = 'LIST_ABNORMAL_RISK_LEVEL_SUMMARY_SUCCESS'
export const LIST_ABNORMAL_RISK_LEVEL_SUMMARY_FAIL = 'LIST_ABNORMAL_RISK_LEVEL_SUMMARY_FAIL'

export const CREATE_ABNORMAL_RISK_LEVEL_REQUEST = 'CREATE_ABNORMAL_RISK_LEVEL_REQUEST'
export const CREATE_ABNORMAL_RISK_LEVEL_SUCCESS = 'CREATE_ABNORMAL_RISK_LEVEL_SUCCESS'
export const CREATE_ABNORMAL_RISK_LEVEL_FAIL = 'CREATE_ABNORMAL_RISK_LEVEL_FAIL'

export const DETAIL_ABNORMAL_RISK_LEVEL_REQUEST = 'DETAIL_ABNORMAL_RISK_LEVEL_REQUEST'
export const DETAIL_ABNORMAL_RISK_LEVEL_SUCCESS = 'DETAIL_ABNORMAL_RISK_LEVEL_SUCCESS'
export const DETAIL_ABNORMAL_RISK_LEVEL_FAIL = 'DETAIL_ABNORMAL_RISK_LEVEL_FAIL'

export const UPDATE_ABNORMAL_RISK_LEVEL_REQUEST = 'UPDATE_ABNORMAL_RISK_LEVEL_REQUEST'
export const UPDATE_ABNORMAL_RISK_LEVEL_SUCCESS = 'UPDATE_ABNORMAL_RISK_LEVEL_SUCCESS'
export const UPDATE_ABNORMAL_RISK_LEVEL_FAIL = 'UPDATE_ABNORMAL_RISK_LEVEL_FAIL'

export const DELETE_ABNORMAL_RISK_LEVEL_REQUEST = 'DELETE_ABNORMAL_RISK_LEVEL_REQUEST'
export const DELETE_ABNORMAL_RISK_LEVEL_SUCCESS = 'DELETE_ABNORMAL_RISK_LEVEL_SUCCESS'
export const DELETE_ABNORMAL_RISK_LEVEL_FAIL = 'DELETE_ABNORMAL_RISK_LEVEL_FAIL'

export const UPDATE_POSITION_ABNORMAL_RISK_LEVEL_REQUEST = 'UPDATE_POSITION_ABNORMAL_RISK_LEVEL_REQUEST'
export const UPDATE_POSITION_ABNORMAL_RISK_LEVEL_SUCCESS = 'UPDATE_POSITION_ABNORMAL_RISK_LEVEL_SUCCESS'
export const UPDATE_POSITION_ABNORMAL_RISK_LEVEL_FAIL = 'UPDATE_POSITION_ABNORMAL_RISK_LEVEL_FAIL'

export const RESET_ABNORMAL_RISK_LEVEL = 'RESET_ABNORMAL_RISK_LEVEL'

